import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import {
  BreakpointObserver,
  BreakpointState,
} from '@angular/cdk/layout';
import { EMPTY, Observable } from 'rxjs';
import { Mobile_breakpoint } from './breakpoints';

@Injectable({
  providedIn: 'root',
})
export class DeviceDetectorService {
  private platformId = inject(PLATFORM_ID);
  private breakpointObserver = inject(BreakpointObserver);

  isDesktop: boolean;
  private isDesktopBreakpoint: Observable<BreakpointState>;

  constructor() {
    // Only observe breakpoints in browser (BreakpointObserver uses window.matchMedia internally)
    if (isPlatformBrowser(this.platformId)) {
      this.isDesktopBreakpoint =
        this.breakpointObserver.observe([`(min-width: ${Mobile_breakpoint}px)`]);
      this.isDesktopBreakpoint.subscribe((size) => {
        this.isDesktop = size.matches;
      });
    } else {
      this.isDesktopBreakpoint = EMPTY;
      this.isDesktop = false; // Default for server-side rendering
    }
  }

  public $breakpoint(): Observable<BreakpointState> {
    return isPlatformBrowser(this.platformId)
      ? this.isDesktopBreakpoint
      : EMPTY;
  }
}
